import React, { Component } from 'react';

class PassingTimesMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Página de tempos de passagem</h2>
                <p>
                    Nesta página encontra os tempos de passagem por cada paragem de uma linha, num percurso e num horário selecionados.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Editar o período de funcionamento do operador para datas selecionadas na rede ativa e na de rascunho</li>
                    <li>Adicionar notas às viagens disponíveis na rede ativa e na de rascunho</li>
                    <li>Eliminar viagens na rede ativa e na de rascunho</li>
                    <li>Comparar as viagens da rede ativa com as da rede de rascunho</li>
                </ul>
            </div>
        );
    }
}

export default PassingTimesMetadata;